import { CheckmarkMedium as IconComponent } from '@adobe/react-spectrum-ui/dist/CheckmarkMedium.js';
import { UIIcon } from '@react-spectrum/icon';
import React from 'react';
export default function CheckmarkMedium(props) {
  return /*#__PURE__*/React.createElement(UIIcon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}